import React from "react";
import { Download, LogOut, Moon } from "lucide-react";

const LOGO_URL = "https://u4rad.com/static/media/Logo.c9920d154c922ea9e355.png";


export default function DashboardHeader({ ecgClient, onLogout, onReportsClick, onToggleTheme }) {
  const welcomeName =
    ecgClient?.username ||
    [ecgClient?.first_name, ecgClient?.last_name].filter(Boolean).join(" ") ||
    "User";

  

  return (
    <header className="bg-white border-b border-[#E5E7EB] sticky top-0 z-20">
      <div className="w-full px-4 sm:px-6 lg:px-8 py-3 flex items-center justify-between gap-4">
        <div className="flex items-center gap-3 min-w-0">
          <img src={LOGO_URL} alt="U4RAD" className="h-8 w-auto shrink-0" />
          <h1 className="text-base sm:text-lg font-semibold text-[#1F2937] truncate">
            ECG Client Dashboard
          </h1>
        </div>

        <div className="flex items-center gap-2 sm:gap-4 shrink-0">
          <span className="hidden sm:inline text-sm text-[#374151] truncate max-w-[220px]">
            Welcome, <span className="font-medium">{welcomeName}</span>
          </span>

          {/* Phase 2: onReportsClick should navigate to the Reports route once it exists */}
          <button
            onClick={onReportsClick}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-[#F3F4F6] text-[#374151] hover:bg-[#E5E7EB] transition-colors"
          >
            <Download className="w-4 h-4" />
            <span className="hidden sm:inline">Reports</span>
          </button>

          {/* Phase 3: onToggleTheme will drive real dark mode once ThemeProvider exists */}
          {/* <button
            onClick={onToggleTheme}
            aria-label="Toggle theme"
            className="p-2 rounded-lg text-[#6B7280] hover:bg-[#F3F4F6] transition-colors"
          >
            <Moon className="w-4 h-4" />
          </button> */}

          <button
            onClick={onLogout}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg bg-[#DC2626] text-white hover:bg-[#B91C1C] transition-colors"
          >
            <LogOut className="w-4 h-4" />
            Logout
          </button>
        </div>
      </div>
    </header>
  );
}